import { SurveyStyles } from "../types/Survey";

export const ORG_COLOR = "<%=Organization.Color%>";

export const DARK_SCHEME_COLORS = {
    cardBackground: "#1D2530",
    text: "#FCFCFC",
    accent: "#88B9FE",
    muted: "#A9AFB7",
    control: "#3D4551"
};

export function defaultSurveyStyles(supportedColorSchemes?: SurveyStyles["supportedColorSchemes"]): SurveyStyles {
    return {
        supportedColorSchemes,
        progressBarColor: ORG_COLOR,
        nextButtonBackgroundColor: ORG_COLOR,
        nextButtonTextColor: "#FFFFFF",
        titleAlignment: "Left",
        textAlignment: "Left",
        detailTextAlignment: "Left",
        titleFontSize: "24",
        iconImageAlignment: "left",
        iconImageSize: "60",
        contentItemIconColor: "#FFFFFF",
        contentItemIconSize: "Medium",
        contentItemIconAlignment: "Top",
        contentItemIconBackground: "Circle",
        contentItemIconBackgroundColor: ORG_COLOR
    };
}
